<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { OnClickOutside } from '@vueuse/components';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update']);
const { t } = useI18n();
const isFilterOpen = ref(false);

const statusOptions = computed(() => [
  { label: t('AILAB.DOCUMENTS.FILTER.ALL'), value: 'all', action: 'filter' },
  {
    label: t('AILAB.DOCUMENTS.FILTER.RETRYABLE'),
    value: 'retryable',
    action: 'filter',
  },
  {
    label: t('AILAB.DOCUMENTS.STATUS.IN_PROGRESS'),
    value: 'in_progress',
    action: 'filter',
  },
  {
    label: t('AILAB.DOCUMENTS.STATUS.AVAILABLE'),
    value: 'available',
    action: 'filter',
  },
  {
    label: t('AILAB.DOCUMENTS.STATUS.BLOCKED'),
    value: 'blocked',
    action: 'filter',
  },
  {
    label: t('AILAB.DOCUMENTS.STATUS.FAILED'),
    value: 'failed',
    action: 'filter',
  },
]);

const selectedStatusLabel = computed(() => {
  const item = statusOptions.value.find(o => o.value === props.status);
  return t('AILAB.DOCUMENTS.FILTER.LABEL', { selected: item?.label || '' });
});

const handleStatusFilterChange = ({ value }) => {
  isFilterOpen.value = false;
  emit('update', value);
};
</script>

<template>
  <OnClickOutside @trigger="isFilterOpen = false">
    <Button
      :label="selectedStatusLabel"
      icon="i-lucide-chevron-down"
      size="sm"
      color="slate"
      trailing-icon
      class="max-w-56"
      @click="isFilterOpen = !isFilterOpen"
    />

    <DropdownMenu
      v-if="isFilterOpen"
      :menu-items="statusOptions"
      class="mt-2"
      @action="handleStatusFilterChange"
    />
  </OnClickOutside>
</template>
